export enum State {
	UNDER_REVIEW = 'En étude',
	PENDING = 'En attente',
	ON_THE_WAY = 'En route',
	IN_PROGRESS = 'En cours',
	FINISHED = 'Terminée',
	CANCELED = 'Annulée',
	CANCELED_FOR_EMPLOYEE = 'Annulée (intervenant absent)',
	CANCELED_FOR_BENEFICIAIRE = 'Annulée (bénéficiaire absent)'
}
